import { CALL_API, Schemas } from '../../common/middleware/api';

export const MAKEUP_SUMMARY_BY_CHILD_AND_TERM_REQUEST = 'MAKEUP_SUMMARY_BY_CHILD_AND_TERM_REQUEST';
export const MAKEUP_SUMMARY_BY_CHILD_AND_TERM_SUCCESS = 'MAKEUP_SUMMARY_BY_CHILD_AND_TERM_SUCCESS';
export const MAKEUP_SUMMARY_BY_CHILD_AND_TERM_FAILURE = 'MAKEUP_SUMMARY_BY_CHILD_AND_TERM_FAILURE';

export const loadMakeupSummaryByChildAndTerm = (childId, termId) => ({
	[CALL_API]: {
		types: [MAKEUP_SUMMARY_BY_CHILD_AND_TERM_REQUEST, MAKEUP_SUMMARY_BY_CHILD_AND_TERM_SUCCESS, MAKEUP_SUMMARY_BY_CHILD_AND_TERM_FAILURE],
		endpoint: 'api/childLessons/makeupSummary',
		request: { childId, termId },
		schema: Schemas.MAKEUP_SUMMARY_ARRAY
	},
	childId,
	termId
})
